import React from 'react';
import ValidatorContentSection from './ValidatorContentSection';
import { iterableValidatorSections } from '../../../helpers/types/iterableEnums';
import { computeRemSize } from '@ydistri/theme';
import { Column } from '@ydistri/ds';

interface ValidatorContentProps {
  templateId: number;
}

const ValidatorContent: React.FC<ValidatorContentProps> = ({ templateId }) => {
  return (
    <Column $width={computeRemSize(374)} $gap="1rem">
      {iterableValidatorSections.map(section => (
        <ValidatorContentSection key={section} section={section} templateId={templateId} />
      ))}
    </Column>
  );
};

export default ValidatorContent;
